import { TagOption } from '@/components/core/HorizontalTagInput/HorizontalTagInput.hooks'

export type DataSourceType = 'social' | 'press'
export type PolarityType = 'POSITIVO' | 'NEGATIVO' | 'FAVORAVEL' | 'DESFAVORAVEL' | 'NEUTRO'
export type TabType = 'social' | 'press' | 'test' | string
export type BrandTab = {
  id: string
  name: string
  isMainBrand: boolean
}
export type RowType =
  | 'positive'
  | 'negative'
  | 'favorable'
  | 'unfavorable'
  | 'neutral'
  | 'positiveFavorable'
  | 'negativeUnfavorable'

export enum ClassificationTestStage {
  POLARITY = 'POLARITY',
  INTENSITY = 'INTENSITY',
  THEMES = 'THEMES',
  GROUPTHEMES = 'GROUPTHEMES',
  ROLE = 'ROLE',
  POLARITY_INTENSITY = 'POLARITY_INTENSITY',
  KEY_MESSAGE = 'KEY_MESSAGE',
  CITATION_IN_TITLE = 'CITATION_IN_TITLE',
  SPOKESPERSON = 'SPOKESPERSON',
}

export interface ExpandedRowsState {
  positive: boolean
  negative: boolean
  favorable: boolean
  unfavorable: boolean
  neutral: boolean
  positiveFavorable: boolean
  negativeUnfavorable: boolean
}

export interface RulesState {
  global: {
    contextRules: string
    priorityFirstStage: string
    prioritySecondStage: string
  }
  brands: Record<string, BrandRules>
}

export interface TermsState {
  [brandId: string]: BrandTerms
}

export interface FocusState {
  [brandId: string]: BrandFocus
}

export interface BrandRules {
  social: {
    positiveGeneral: string
    positiveSpecific: string
    negativeGeneral: string
    negativeSpecific: string
    favorableGeneral: string
    favorableSpecific: string
    unfavorableGeneral: string
    unfavorableSpecific: string
    neutralRules: string
  }
  press: {
    positiveGeneral: string
    positiveSpecific: string
    negativeGeneral: string
    negativeSpecific: string
    favorableGeneral: string
    favorableSpecific: string
    unfavorableGeneral: string
    unfavorableSpecific: string
    neutralRules: string
  }
}

export interface BrandTerms {
  socialPositivePublishersTags: TagOption[]
  socialNegativePublishersTags: TagOption[]
  socialFavorablePublishersTags: TagOption[]
  socialUnfavorablePublishersTags: TagOption[]
  socialPositiveProprietaryTags: TagOption[]
  socialNegativeProprietaryTags: TagOption[]
  socialFavorableProprietaryTags: TagOption[]
  socialUnfavorableProprietaryTags: TagOption[]
  pressPositiveChannelsTags: TagOption[]
  pressNegativeChannelsTags: TagOption[]
  pressFavorableChannelsTags: TagOption[]
  pressUnfavorableChannelsTags: TagOption[]
  pressPositiveProprietaryTags: TagOption[]
  pressNegativeProprietaryTags: TagOption[]
  pressFavorableProprietaryTags: TagOption[]
  pressUnfavorableProprietaryTags: TagOption[]
  socialPositiveFavorablePublishersTags: TagOption[]
  socialPositiveFavorableProprietaryTags: TagOption[]
  socialNegativeUnfavorablePublishersTags: TagOption[]
  socialNegativeUnfavorableProprietaryTags: TagOption[]
  pressPositiveFavorableChannelsTags: TagOption[]
  pressPositiveFavorableProprietaryTags: TagOption[]
  pressNegativeUnfavorableChannelsTags: TagOption[]
  pressNegativeUnfavorableProprietaryTags: TagOption[]
}

export interface BrandFocus {
  socialClientFocusTags: TagOption[]
  socialCompetitorFocusTags: TagOption[]
  pressClientFocusTags: TagOption[]
  pressCompetitorFocusTags: TagOption[]
}

export interface ClassificationTestItem {
  id: string
  startDate: string
  endDate: string
  dataSource: 'social' | 'press'
  status: 'PENDING' | 'PROCESSING' | 'FINISHED' | 'ERROR'
  stages: ClassificationTestStage[]
  createdAt: string
  updatedAt: string
  completedAt?: string
  taskArn?: string
  errorMessage?: string
  resultFilePath?: string
}
